<ngx-datatable
  scResizeTable
  [columnMode]="'force'"
  [headerHeight]="50"
  [footerHeight]="50"
  [rowHeight]="'auto'"
  [scrollbarV]="scrollable"
  [rows]="actions"
  [limit]="tableOptions.limit"
  [count]="tableOptions.total"
  [offset]="tableOptions.offset"
  [externalPaging]="true"
  class="material no-click"
  [virtualization]="!scrollable"
  [loadingIndicator]="loading"
  [messages]="messages"
  [ngStyle]="fixedHeight ? { height: fixedHeight } : {}"
  [rowClass]="getRowClass"
  (page)="onPage($event)">
  <ngx-datatable-column prop="ActionTypeName" name="{{ 'ACTION_TYPE' | translate }}" [sortable]="false">
    <ng-template let-action="row" ngx-datatable-cell-template>
      <span
        class="icon-inline action-icon"
        [ngClass]="{
          'txt-danger': action.IsError,
          'txt-orange': action.IsWarning && !action.IsError
        }">
        @if (action.typeLog) {
          <mat-icon class="mr-1">
            {{ action | action: 'icon' }}
          </mat-icon>
        }
        <span>
          {{ action | action: 'type' }}
        </span>
      </span>
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column name="{{ 'EXTRA' | translate }}" [sortable]="false">
    <ng-template let-action="row" ngx-datatable-cell-template>
      @if (action.typeLog === 'NEW_CHARGING_PROFILE') {
        <sc-limitation-popover
          [value]="action | action: 'extra'"
          title="{{ 'NEW_CHARGING_PROFILE' | translate }}"
          [selected]="action.datas"></sc-limitation-popover>
      }
      @if (action.typeLog !== 'NEW_CHARGING_PROFILE') {
        <span>
          @if (action.ErrorName && (action.ErrorDescription || action.ActionAdvised || action.DescriptionDetails)) {
            <span
              triggers="mouseenter:mouseleave"
              (mouseover)="selectAction(action)"
              class="hover-text"
              placement="auto"
              container="body"
              [ngbPopover]="errorMessagePop">
              {{ action | action: 'extra' }}
            </span>
          }
          <span class="icon-inline action-icon">
            @if (
              (action.typeLog === 'TRANSACTION_REQUEST' || action.typeLog === 'START_TRANSACTION') &&
              action.datas &&
              (action.datas.StartMethod || action.datas.reason)
            ) {
              <span>
                <!-- @TODO: I saw this in another table. Could be compontentized-->
                <span class="start-method">
                  @switch (action.datas.StartMethod || action.datas.reason) {
                    @case ('SMS') {
                      <mat-icon matTooltip="{{ 'STARTED_WITH_SMS' | translate }}"> sms </mat-icon>
                    }
                    @case ('RFID') {
                      <mat-icon matTooltip="{{ 'STARTED_WITH_RFID' | translate }}"> settings_remote </mat-icon>
                    }
                    @case ('QR') {
                      <mat-icon matTooltip="{{ 'STARTED_WITH_QR' | translate }}"> border_outer </mat-icon>
                    }
                    @case ('App') {
                      <mat-icon matTooltip="{{ 'STARTED_WITH_APP' | translate }}"> phone_iphone </mat-icon>
                    }
                    @case ('Dashboard') {
                      <mat-icon matTooltip="{{ 'STARTED_FROM_DASHBOARD' | translate }}"> tv </mat-icon>
                    }
                    @case ('PLUG_AND_CHARGE') {
                      <mat-icon matTooltip="{{ 'STARTED_AUTOMATICALLY' | translate }}"> power </mat-icon>
                    }
                    @case ('ROAMING_REMOTE_START') {
                      <mat-icon matTooltip="{{ 'STARTED_WITH_ROAMING_EMSP' | translate }}"> phone_iphone </mat-icon>
                    }
                    @case ('ROAMING_LOCAL_START') {
                      <mat-icon matTooltip="{{ 'STARTED_WITH_ROAMING_TAG' | translate }}"> settings_remote </mat-icon>
                    }
                    @case ('PAYMENT_TERMINAL') {
                      <mat-icon matTooltip="{{ 'PAYMENT_TERMINAL' | translate }}"> point_of_sale </mat-icon>
                    }
                    @case ('ADD_PAYMENT_CARD') {
                      <mat-icon matTooltip="{{ 'ADD_PAYMENT_CARD' | translate }}"> payments </mat-icon>
                    }
                    @default {
                      <mat-icon matTooltip="{{ 'UNKNOWN_START_METHOD' | translate }}"> power </mat-icon>
                    }
                  }
                </span>
              </span>
            }
            @if (!action.ErrorName && !action.ErrorDescription) {
              <span>
                {{ action | action: 'extra' }}
                @if (
                  action.typeLog === 'AUTOHEAL' &&
                  action?.datas?.reason === 'AutohealSetDefaultConfig' &&
                  action.datas?.keysChanged?.length
                ) {
                  <p>
                    {{ 'WRONG_CONFIGURATIONS_LIST' | translate: { configList: action.datas.keysChanged.join(',') } }}
                  </p>
                }
                @if (action.typeLog === 'BOOT_NOTIFICATION') {
                  <span>
                    @if (getReasonText(action.datas.reason)) {
                      <button
                        mat-icon-button
                        matSuffix
                        type="button"
                        matTooltip="{{ getReasonText(action.datas.reason) | translate }}">
                        <mat-icon>help_outline</mat-icon>
                      </button>
                    }
                  </span>
                }
                @if (action.typeLog === 'NEW_FIRMWARE' && action?.datas?.OldFW && action?.datas?.NewFW) {
                  <span>{{ action.datas.OldFW }}</span>
                  <mat-icon class="mx-1">east</mat-icon>
                  <span>{{ action.datas.NewFW }}</span>
                }
              </span>
            }
          </span>
        </span>
      }
    </ng-template>
  </ngx-datatable-column>
  @if (showPoint) {
    <ngx-datatable-column prop="ChargingPointName" name="{{ 'POINT' | translate }}" [sortable]="false">
      <ng-template let-action="row" ngx-datatable-cell-template>
        @if (action.FK_ChargePointID) {
          <a
            (click)="onRoute()"
            routerLink="/station/{{ action.FK_ChargingStationID }}/point/{{ action.FK_ChargePointID }}/sessions">
            {{ action.FK_ChargePointID }}
          </a>
        } @else {
          –
        }
      </ng-template>
    </ngx-datatable-column>
  }
  @if (showCustomer) {
    <ngx-datatable-column *canSee="userType.Admin" name="{{ 'CUSTOMER' | translate }}" [sortable]="false">
      <ng-template let-action="row" ngx-datatable-cell-template>
        @if (action.FK_CustomerID) {
          <a (click)="onRoute()" routerLink="/users/{{ action.FK_CustomerID }}">
            {{ action.FK_CustomerID }}
          </a>
        }
        @if (!action.FK_CustomerID) {
          <span>-</span>
        }
      </ng-template>
    </ngx-datatable-column>
  }

  <ngx-datatable-column
    prop="Date_log"
    name="{{ 'DATE' | translate }}"
    [resizeable]="false"
    [sortable]="false"
    [minWidth]="180"
    [maxWidth]="180">
    <ng-template let-action="row" ngx-datatable-cell-template>
      {{ action.Date_log | cDate: 'L LTS' }}
    </ng-template>
  </ngx-datatable-column>
  <ngx-datatable-column
    name=""
    [resizeable]="false"
    [sortable]="false"
    [minWidth]="200"
    [maxWidth]="200"
    *canSee="userType.Support"
    cellClass="justify-end">
    <ng-template let-action="row" ngx-datatable-cell-template>
      @if (action.FK_CommandRequestBoxId) {
        <button
          mat-icon-button
          matTooltip="{{ 'REQUEST_DETAILS' | translate }}"
          class="small-button"
          (click)="showRequestDetails(action)">
          <mat-icon>find_in_page</mat-icon>
        </button>
      }
      <button
        mat-icon-button
        matTooltip="{{ 'DETAILS' | translate }}"
        class="small-button"
        (click)="showAction(action)">
        <mat-icon>list_alt</mat-icon>
      </button>
    </ng-template>
  </ngx-datatable-column>

  <ngx-datatable-footer>
    <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-selectedCount="selectedCount">
      <sc-datatable-footer
        tableName="action-history"
        [rowCount]="rowCount"
        [selectedCount]="selectedCount"
        (pageSizeChange)="onLimitChange($event)"></sc-datatable-footer>
    </ng-template>
  </ngx-datatable-footer>
</ngx-datatable>
<ng-template #errorMessagePop>
  <h3 matListItemTitle>{{ selectedAction.ErrorName }}</h3>

  <mat-list>
    <mat-list-item>
      <h4 matListItemTitle>{{ 'DESCRIPTION' | translate }}</h4>
      <p matListItemLine>{{ selectedAction.ErrorDescription }}</p>
      <p matListItemLine>{{ selectedAction.DescriptionDetails }}</p>
    </mat-list-item>

    <mat-list-item>
      <h4 matListItemTitle>{{ 'ACTION_ADVISED' | translate }}</h4>
      <p matListItemLine>{{ selectedAction.ActionAdvised || '-' }}</p>
    </mat-list-item>

    @if (selectedAction.datas && selectedAction.datas.VendorErrorCode) {
      <mat-list-item>
        <h4 matListItemTitle>{{ 'VENDOR_ERROR_CODE' | translate }}</h4>
        <p matListItemLine>{{ selectedAction.VendorErrorCode || '-' }}</p>
      </mat-list-item>
    }
  </mat-list>
</ng-template>
